/* SPACES: portrait / landscape toggle for the to-scale room views */
(function () {
  var L = { hu: ['Álló', 'Fekvő'], en: ['Portrait', 'Landscape'], ro: ['Vertical', 'Orizontal'] };
  var lg = (document.documentElement.lang || 'hu').slice(0, 2), T = L[lg] || L.hu;
  function $(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function swap(el, land) {
    var t = el.textContent, m = t.match(/(\d+)\s*[×x]\s*(\d+)\s*cm/);
    if (!m) return;
    var a = +m[1], b = +m[2];
    if (land ? a < b : a > b) el.textContent = t.replace(m[0], b + '×' + a + ' cm');
  }
  function setup(root, host) {
    if (!host || root.__o) return;
    root.__o = 1;
    var w = document.createElement('span');
    w.className = 'sp-orient';
    w.innerHTML = '<button type="button" class="sp-pill on" data-orient="port"><i class="o-ic"></i>' + T[0] + '</button><button type="button" class="sp-pill" data-orient="land"><i class="o-ic"></i>' + T[1] + '</button>';
    host.appendChild(w);
    var labs = $('.sp-try-lab,.sp-size-lab,.sp-dz-lab', root), land = false;
    function apply(v) {
      land = v;
      $('.sp-scene', root).forEach(function (s) { s.classList.toggle('land', v); if (window.__spFit) window.__spFit(s); });
      $('[data-orient]', w).forEach(function (b) { b.classList.toggle('on', (b.dataset.orient === 'land') === v); });
      labs.forEach(function (l) { swap(l, v); });
    }
    $('[data-orient]', w).forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.orient === 'land'); }); });
    labs.forEach(function (l) { new MutationObserver(function () { swap(l, land); }).observe(l, { childList: true, characterData: true, subtree: true }); });
    var im = root.querySelector('.sp-wa img, .rs-art img');
    if (root.classList.contains('sp-pdp') && im) { var chk = function () { if (im.naturalWidth > im.naturalHeight) apply(true); }; if (im.complete) chk(); else im.addEventListener('load', chk); }
  }
  function init() {
    $('.sp-try').forEach(function (r) { setup(r, r.querySelector('.sp-side')); });
    $('.sp-pdp:not(.flat)').forEach(function (r) { setup(r, r.querySelector('[data-orient-host]') || r.querySelector('.sp-rooms-pills')); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
